// extracted by mini-css-extract-plugin
export var description = "project-module--description--KBO8w";
export var githubLogo = "project-module--github-logo--1CjkG";
export var projectBox = "project-module--project-box--HA29z";
export var projectContent = "project-module--project-content--msVAW";
export var projectImage = "project-module--project-image--RXopa";
export var projectText = "project-module--project-text--4dpoe";
export var title = "project-module--title--CAXQB";